import { fetchDepartmentsAction } from "./actions";
import { push } from "connected-react-router";
import { FirebaseTimestamp, db } from "../../firebase";
import {
  collection,
  doc,
  getDocs,
  deleteDoc,
  orderBy,
  updateDoc,
  addDoc,
  query,
} from "firebase/firestore";

export const saveDepartments = (newDepartment) => {
  return async (dispatch) => {
    const departments = await fetchDepartmentWithNoRedux();
    const timestamp = FirebaseTimestamp.now();
    const batch = [];

    // 1. departmentsに存在し、newDepartmentに存在しないカテゴリを削除
    departments.forEach((department) => {
      const departmentExistsInNew = newDepartment.some(
        (newDepartment) => newDepartment.id === department.id
      );
      if (!departmentExistsInNew) {
        //存在しなかったら
        const docRef = doc(db, "departments", department.id);
        batch.push(deleteDoc(docRef));
      }
    });

    // 2. newDepartmentに存在し、departmentsに存在しないカテゴリを追加
    newDepartment.forEach((newDepartment) => {
      const departmentExistsIndepartments = departments.some(
        (department) => department.id === newDepartment.id
      );
      if (!departmentExistsIndepartments) {
        //存在しなかったら
        const data = {
          id: "",
          did: newDepartment.did,
          name: newDepartment.name,
          base_id: newDepartment.base_id,
          base_name: newDepartment.base_name,
          updated_at: timestamp,
          created_at: timestamp,
        };
        batch.push(addNewDocument(data));
      }
    });

    // 3. departmentsとnewDepartmentの両方に存在するカテゴリを更新
    newDepartment.forEach((newDepartment) => {
      const departmentExistsIndepartments = departments.some(
        (department) => department.id === newDepartment.id
      );
      if (departmentExistsIndepartments) {
        const departmentToUpdate = departments.find(
          (department) => department.id === newDepartment.id
        );
        if (
          JSON.stringify(departmentToUpdate) !== JSON.stringify(newDepartment)
        ) {
          const docRef = doc(db, "departments", newDepartment.id);
          const data = {
            id: newDepartment.id,
            did: newDepartment.did,
            name: newDepartment.name,
            base_id: newDepartment.base_id,
            base_name: newDepartment.base_name,
            updated_at: timestamp,
          };
          batch.push(updateDoc(docRef, data, { merge: true }));
        }
      }
    });

    try {
      await Promise.all(batch);
      dispatch(push("/ordering-department/menu"));
    } catch (error) {
      console.error("Error synchronizing departments: ", error);
      throw new Error(error);
    }
  };
};

const addNewDocument = async (newData) => {
  const collectionRef = collection(db, "departments");

  try {
    const docRef = await addDoc(collectionRef, newData);
    const newDocumentId = docRef.id;
    const newDataWithId = { ...newData, id: newDocumentId };
    const docRefToUpdate = doc(db, "departments", newDocumentId);
    await updateDoc(docRefToUpdate, newDataWithId);
  } catch (error) {
    console.error("Error adding document: ", error);
  }
};

export const fetchdepartments = () => {
  return async (dispatch) => {
    const q = query(collection(db, "departments"), orderBy("did", "asc"));
    const querySnapshot = await getDocs(q);
    const list = [];
    querySnapshot.forEach((doc) => {
      const data = doc.data();
      list.push({
        id: data.id,
        did: data.did,
        name: data.name,
        base_id: data.base_id,
        base_name: data.base_name,
      });
    });
    dispatch(fetchDepartmentsAction(list));
  };
};

const fetchDepartmentWithNoRedux = async () => {
  const q = query(collection(db, "departments"), orderBy("id", "asc"));
  const querySnapshot = await getDocs(q);
  const list = [];
  querySnapshot.forEach((doc) => {
    const data = doc.data();
    list.push({
      id: doc.id,
      did: data.did,
      name: data.name,
      base_id: data.base_id,
      base_name: data.base_name,
    });
  });
  return list;
};
